<template>
  <div class="p-6 pt-2 mb-6">
    <div class="mb-5">

		
		<!-- <span class="counter-remaining">{{ current_count+' remaining' }}</span> -->
		<div class="p-4">
			<div class="row">


				<p class="mt-5 float-right flex ">
					<input placeholder="" v-model="circle_marker_radius" class="text-right px-3 py-2 ml-3"/>
					<small class="mb-0 pb-0 pt-2 pl-2">METERS</small>
				</p>
				<p class="mt-5 float-right flex ">
					<GmapAutocomplete @place_changed="setPlace" class="px-3 py-2 ml-3">
					</GmapAutocomplete>
					<button @click="usePlace" class="px-2">Reposition</button>
				</p>
				<p class="mt-5 float-right flex ">
					<input placeholder="" v-model.number="circle_c.lng" class="text-right px-3 py-2 ml-3"/>
					<small class="mb-0 pb-0 pt-2 pl-2">LNG</small>
				</p>
				<p class="mt-5 float-right flex ">
					<input placeholder="" v-model.number="circle_c.lat" class="text-right px-3 py-2 ml-3"/>
					<small class="mb-0 pb-0 pt-2 pl-2">LAT</small>
				</p>
				<h3 class="col-12">
				Historical Seismic Activity
				</h3>
				<small class="col-12">{{(quakes_list.length > 1 ? quakes_list.length+' instances':quakes_list.length+' instance')+' occured inside the '+(circle_marker_radius/1000).toFixed(2)+' KM radius'}}</small>
			</div>

		</div>
        <div class="mt-5" v-bind:class="map_is_idle ? 'is-idle':'is-loading'" :remaining="'Plotting points. Please wait...'">
			<vs-row vs-w="12">
				<vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="7">

					<div class="vx-card p-6 w-100">
						<div class="row w-100 mb-3">
							
							<p class="float-left flex ">
								<input type="checkbox" class="mt-2 mx-2" id="include-magnitude-min" v-model="include_min_magnitude" > 
									
								<label class="mb-0 pb-0 pt-1 pl-2" for="include-magnitude-min">Include Magnitude below or equal to </label><br/>
								<input placeholder="" v-model.number="minimum_magnitude" min="0" max="9" type="number" class="text-right px-1 ml-3"/>
							</p>
							
							<p class="col-12 mb-5 float-right">
								<b>Marker Radius</b> &nbsp; &nbsp;{{parseInt(circle_marker_radius)+' M ('+(parseInt(circle_marker_radius)/1000).toFixed(2)+' KM)'}} <br/>
								<b>Marker Center</b> &nbsp; &nbsp;{{parseFloat(circle_marker_center.lat).toFixed(3)+' N'+', '+parseFloat(circle_marker_center.lng).toFixed(3)+' E'}}
							</p>
							<!-- <small class="col-12">{{(quakes_list.length > 1 ? quakes_list.length+' instances':quakes_list.length+' instance')+' occured inside the '+(parseInt(circle_marker_radius)/1000).toFixed(2)+' KM radius'}}</small> -->
						</div>

						<div class="card-content mt-5 pt-5">

							<div class="card-body">
								<div class="card-text">
								<aggrid-table-modular :data="quakes_list" :column-defs="columnDefs"></aggrid-table-modular>
								</div>
							</div>
						</div>

					</div>
				</vs-col>
				<vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="5">
					<GmapMap
						ref = 'gmap_instance'
						:center="center"
						:zoom="7"
						map-type-id="terrain"
						@idle="mapIsIDLE"
						@click="updateMarkerCenter"
						style="width: 100%; height: 100%; display: block">
							
							<GmapCircle
								v-for="(pin, index) in markers"
								:key="index"
								:center="pin.position"
								:radius="pin.radius"
								:visible="true"
								:options="pin.option"
							></GmapCircle>
							<GmapCircle
								ref = "marker_circle"
								:center="circle_c"
								:radius="parseInt(circle_marker_radius)"
								:visible="true"
								:options="{
									fillColor:'red',
									fillOpacity:.4,
									strokeColor:'red',
									strokeOpacity: 0.4,
								}"
								label= "1"
								@radius_changed="updateCircleMarkerRadius"
								@center_changed="updateCircleMarkerCenter"
								:editable="true"
							></GmapCircle>
					</GmapMap>
				</vs-col>
			</vs-row>

				
        </div>
		

    </div>
	<div class="excel-import mt-5">
		<input type="file" ref="fileInput" class="hidden" accept=".xlsx, .xls" @change="handleClick">
		<div
		@click="$refs.fileInput.click()"
		@drop="handleDrop"
		@dragover="handleDragover"
		@dragenter="handleDragover"
		class="px-8 py-16 cursor-pointer text-center border-2 border-dashed d-theme-border-grey d-theme-dark-bg text-md">
		<feather-icon icon="UploadCloudIcon" svgClasses="h-11 w-11 stroke-current text-grey" class="block" />
		<span>To update the data, please drop the excel template here or </span>
		<span class="font-medium text-primary" @click.stop="$refs.fileInput.click()">Browse</span>
		<!-- <vs-button type="border" @click.stop="$refs.fileInput.click()">Browse</vs-button> -->
		</div>
	</div>
	<a href="/main.xlsx" download  class="my-3 float-left"><p>Download the sample XLSX Template here</p></a>
	<a href="/default.xlsx" download class="my-3 float-right"><p>Download the default data here</p></a>
	<vs-button color="warning" class="flex mx-auto mt-5" @click="resetCookies">Reset to default data</vs-button>
  </div>
</template>

<script>
import XLSX from 'xlsx';
import { writeFile } from 'fs-web';
import {gmapApi} from 'vue2-google-maps'
import default_data from '../data/default-data.JSON'
export default{
  data() {
    return {
		data: null,
		center: { lat: 12.8797, lng: 121.7740 },
		circle_marker_center: { lat: 12.8797, lng: 121.7740 },
		circle_c: { lat: 12.8797, lng: 121.7740 },
		circle_marker_radius: 100000,
		markers: [],
		quakes_list: [],
		quakes_list_holder: [],
		map_is_idle: false,
		data: [],
		columnDefs: [],
		place: null,
		include_min_magnitude: true,
		minimum_magnitude: 5
		// current_count: 0
    }
  },
  computed: {
	google: gmapApi,
  },
  created(){
	  
	  if(typeof localStorage.markers !== 'undefined'){
		  this.markers = JSON.parse(localStorage.markers)
	  }else{
		  this.current_count = this.markers.length
		  this.map_is_idle = false
		  this.markers = default_data		
	  }
  },
  mounted(){  

	this.columnDefs = [
		{headerName: 'From epicenter', width: 180, field: 'distance_from_marker_center', cellRenderer: (params)=>{return  typeof params.data.distance_from_marker_center !== 'undefined' ? params.data.distance_from_marker_center.toFixed(2) +' KM' : 'Not specified'}, filter: true, sortable: true, pinned: 'left'},
		// {headerName: 'Date', field: 'other_details.year', cellRenderer: (params)=>{return params.data.other_details.year+'/'+params.data.other_details.month+'/'+params.data.other_details.day+' '+params.data.other_details.hour+':'+params.data.other_details.minute+':'+params.data.other_details.second }, filter: true, sortable: true, width: 200},
		{headerName: 'Year', field: 'other_details.year', filter: true, sortable: true, width: 120, pinned: 'left'},
		{headerName: 'Month', field: 'other_details.month', cellRenderer: (params)=>{return this.$moment(params.data.other_details.month, 'M').format('MMMM') !== 'Invalid date' ? this.$moment(params.data.other_details.month, 'M').format('MMMM') : params.data.other_details.month }, filter: true, sortable: true, width: 120, pinned: 'left'},
		{headerName: 'Day', field: 'other_details.day', filter: true, sortable: true, width: 100, pinned: 'left'},
		// {headerName: 'Coordinates', field: 'position.lat', cellRenderer: (params)=>{return params.data.position.lat+' N, '+params.data.position.lng+' E' }, width: 150},
		{headerName: 'Magnitude', field: 'other_details.magnitude', filter: true, sortable: true, width: 120, cellStyle: { textAlign: 'center' }},
		{headerName: 'Depth (KM)', field: 'other_details.depth', cellRenderer: (params)=>{return params.data.other_details.depth+' KM' }, filter: true, sortable: true, width: 130},
		{headerName: 'Ml', field: 'other_details.ml', filter: true, sortable: true, width: 120, cellStyle: { textAlign: 'center' }},
		{headerName: 'Mb', field: 'other_details.mb', filter: true, sortable: true, width: 120, cellStyle: { textAlign: 'center' }},
		{headerName: 'Ms', field: 'other_details.ms', filter: true, sortable: true, width: 120, cellStyle: { textAlign: 'center' }},
		{headerName: 'North (Latitude)', field: 'position.lat', filter: true, sortable: true, width: 200, cellStyle: { textAlign: 'center' }},
		{headerName: 'East (Longitude)', field: 'position.lng', filter: true, sortable: true, width: 200, cellStyle: { textAlign: 'center' }},
		// {headerName: 'Magnitude', autoHeight: true, field: 'other_details.ms', cellRenderer: (params)=>{return `
		// 		<div class="magnitude-col">
		// 			${typeof params.data.other_details.ml !== 'undefined' ? '(ML)  '+params.data.other_details.ml : '(ML) Not specified'}, 
		// 			${typeof params.data.other_details.mb !== 'undefined' ? '(MB)  '+params.data.other_details.mb : '(MB) Not specified'}, 
		// 			${typeof params.data.other_details.ms !== 'undefined' ? '(MS)  '+params.data.other_details.ms : '(MS) Not specified'}, 
		// 		</div>
		// 	` }, filter: true, sortable: true, width: 400},
		{headerName: 'Intensity description', field: 'other_details.intensity', cellRenderer: (params)=>{return params.data.other_details.intensity }, filter: true, sortable: true, width: 600},
		// {headerName: 'Updated', field: 'updated_at', cellRenderer: (params)=>{return this.$ghelper.formatDate(params.data.updated_at, 'LLL') }, filter: true, sortable: true, width: 250},
	]
	this.getQuakes()
	// console.log(this.$refs.gmap_instance)
  },
  watch:{
	include_min_magnitude(bool){
		if(bool){
			this.quakes_list = this.quakes_list_holder
		}else{
			this.removeBelowMinMagnitude()
		}
	},
	minimum_magnitude(){
		console.log(this.include_min_magnitude)
		if(this.include_min_magnitude){
			this.quakes_list = this.quakes_list_holder
		}else{
			this.removeBelowMinMagnitude()
		}
	},
	circle_marker_center: {
		handler(val){
		// this.circle_c = {
		// 	lat: parseFloat(val.lat),
		// 	  lng: parseFloat(val.lng),
		//   }
		// 	  console.log(val)
		},
		deep: true
	}
  },
  methods:{
	removeBelowMinMagnitude(){
		this.quakes_list_holder = this.quakes_list
		var result = []
		for (const key in this.quakes_list) {
			if (Object.hasOwnProperty.call(this.quakes_list, key)) {
				const tremor = this.quakes_list[key];
				if(tremor.other_details.magnitude >= this.minimum_magnitude){
					result.push(tremor)
				}
			}
		}
		this.quakes_list = result
	},
    setPlace(place) {
      this.place = place
    },
    usePlace(place) {
      if (this.place) {
        // this.markers.push({
        this.circle_c = {
            lat: this.place.geometry.location.lat(),
            lng: this.place.geometry.location.lng(),
          }
        // })
        this.place = null;
      }
    },
	  resetCookies(){
		  
		//   this.map_is_idle = false
		  localStorage.removeItem('markers');
		//   this.map_is_idle = false
		  this.markers = default_data
		  this.getQuakes()
		//   this.$router.push('/refresh').catch(() => {})
	  },
	  updateMarkerCenter(e){
		  this.circle_c = {
			  lat: e.latLng.lat(),
			  lng: e.latLng.lng(),
		  }

	  },
	  mapIsIDLE(idle){
		  this.map_is_idle = true
	  },
	  updateCircleMarkerCenter(e){
		  console.log('center changed: ', e)
		  this.circle_marker_center = {
			  lat: e.lat(),
			  lng: e.lng(),
		  }
		  this.getQuakes()
	  },
	  updateCircleMarkerRadius(e){
		  console.log('radius changed: ', e)
		  this.circle_marker_radius = e
		  this.getQuakes()
	  },
	  getQuakes(){
		  var quakes = []
		  this.markers.forEach(marker => {
			  var dist_from_center = this.computeDistance(this.circle_marker_center.lat, this.circle_marker_center.lng, marker.position.lat, marker.position.lng)
			  marker.distance_from_marker_center = dist_from_center
			if(dist_from_center  <= parseInt(this.circle_marker_radius)/1000){
				// console.log(dist_from_center +" <= "+this.circle_marker_radius/1000)
				quakes.push(marker)
			}
		  });
		  this.quakes_list = quakes
		  this.quakes_list_holder = quakes
		//   console.log(this.quakes_list)
	  },
	  computeDistance(lat1, lng1, lat2, lng2){
		var R = 6371; // km
		var dLat = this.toRad(lat2-lat1);
		var dLon = this.toRad(lng2-lng1);
		var lat1 = this.toRad(lat1);
		var lat2 = this.toRad(lat2);

		var a = Math.sin(dLat/2) * Math.sin(dLat/2) +
			Math.sin(dLon/2) * Math.sin(dLon/2) * Math.cos(lat1) * Math.cos(lat2); 
		var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)); 
		var d = R * c;
		return d;
	  },
	  toRad(Value){
			return Value * Math.PI / 180;
	  },
	  setMarkers(list){
		  
		if(list != null){
			if(typeof localStorage.markers !== 'undefined' && localStorage.markers !== '[]'){
				this.markers = JSON.parse(localStorage.markers)
				// this.current_count = this.markers.length
				this.map_is_idle = true
				// this.current_count = 0
			}else{
			  this.markers = []
			//   console.log(list.length)
			//   this.current_count = list.length
			//   console.log(this.current_count)
			  for (const key in list) {
					  if (Object.hasOwnProperty.call(list, key)) {
						  const eq_instance = list[key];
						  this.markers.push({
												  position: {
													  lat: parseFloat(eq_instance.latitude), 
													  lng: parseFloat(eq_instance.longitude),
												  },
												  radius: this.getMagnitudeValue(eq_instance),
												  option: this.getMagnitudeAttributes(eq_instance),
												  other_details: eq_instance
											  })
						//   this.current_count = this.current_count - 1
			  			// 	console.log(this.current_count)
						  //   console.log(eq_instance)
					  }
				}
			
			this.map_is_idle = true
			localStorage.markers = JSON.stringify(this.markers)
			
			this.getQuakes()
			}
		}
	  },
	 getMagnitudeAttributes(instance){
		 return {
					fillColor:this.getDepthColor(instance.depth), 
					fillOpacity:0.6,
					strokeOpacity: 0.8,
					strokeWeight: .3,
		 		}
	 },
	 getMagnitude(ins){
		 if(typeof ins.ms != 'undefined'){
		 	return ins.ms
		 }else if(typeof ins.ml != 'undefined'){
		 	return ins.ml
		 }else if(typeof ins.mb != 'undefined'){
		 	return ins.mb
		 }else{
			return 3.0
		 }
	 },
	 getDepthColor(depth){
		 depth = parseInt(depth)
		 if(depth >= 0 && depth <= 65){
			 return '#f0f82c'
		 }
		 if(depth > 65 && depth <= 150){
			 return '#59ff00'
		 }
		 if(depth > 150 && depth <= 300){
			 console.log('red')
			 return '#f50e00'
		 }
		 if(depth > 300){
			 console.log('blue')
			 return '#0000ec'
		 }
		 return 'orange'
	 },
	 getMagnitudeValue(ins){
		var magnitude = this.getMagnitude(ins)
		if(magnitude <= 4.0){
			return 2500
		}
		if(magnitude >= 4.0 && magnitude < 4.5){
			return 3000
		}
		if(magnitude >= 4.5 && magnitude < 5.0){
			return 3500
		}
		if(magnitude >= 5.0 && magnitude < 5.5){
			return 4000
		}
		if(magnitude >= 5.5 && magnitude < 6.0){
			return 4500
		}
		if(magnitude >= 6.0 && magnitude < 6.5){
			return 5000
		}
		if(magnitude >= 6.5 && magnitude < 7.0){
			return 5500
		}
		if(magnitude >= 7.0 && magnitude < 7.5){
			return 6000
		}
		if(magnitude >= 7.5 && magnitude < 8){
			return 6500
		}
		if(magnitude >= 8){
			return 7000
		}
		return 20000
	 },
	 resetData(){
		 localStorage.removeItem("markers");
		 localStorage.removeItem("data");
		 this.markers = []
		 this.data = null
	 },
	 addMagnitudeColumn(object){
		 var result = []
		 for (const key in object) {
			 if (Object.hasOwnProperty.call(object, key)) {
				 const row = object[key];
				//  console.log(row)
				 row.magnitude = 0
				 if(typeof row.ml !== 'undefined'){
					 if(row.ml >= row.magnitude){
						 row.magnitude = row.ml
					 }
				 }
				 if(typeof row.mb !== 'undefined'){
					 if(row.mb >= row.magnitude){
						 row.magnitude = row.mb
					 }
				 }
				 if(typeof row.ms !== 'undefined'){
					 if(row.ms >= row.magnitude){
						 row.magnitude = row.ms
					 }
				 }
				 result.push(row)
			 }
		 }
		 return result
	 },
     importExcel(files) {
   	  this.resetData()
    //   const files = e.target.files;
    //   console.log(files);
      if (!files.length) {
        return ;
      } else if (!/\.(xls|xlsx)$/.test(files[0].name.toLowerCase())) {
        return alert("The upload format is incorrect. Please upload xls or xlsx format");
      }
      const fileReader = new FileReader();
      fileReader.onload = async ev => {
        try {
          const data = ev.target.result;
        //   const XLSX = XLSX;
          const workbook = XLSX.read(data, {
            type: "binary"
          });
          const wsname = workbook.SheetNames[0]; // Take the first sheet，wb.SheetNames[0] :Take the name of the first sheet in the sheets
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]); // Generate JSON table content，wb.Sheets[Sheet名]    Get the data of the first sheet
          const excellist = [];  // Clear received data
          // Edit data
          for (var i = 0; i < ws.length; i++) {
            excellist.push(ws[i]);
          }
		  	// console.log("Read results", excellist); // At this point, you get an array containing objects that need to be processed
			// this.data = excellist
			// localStorage.data = JSON.stringify(excellist)
			// console.log(this.addMagnitudeColumn(excellist))
			this.setMarkers(this.addMagnitudeColumn(excellist))	

        } catch (e) {
			console.log(e)
          return alert("Read failure!");;
        }
      };
      fileReader.readAsBinaryString(files[0]);
      var input = document.getElementById("upload");
    //   input.value = "";
	},
	
    handleDragover (e) {
      e.stopPropagation()
      e.preventDefault()
      e.dataTransfer.dropEffect = 'copy'
    },
    handleDrop (e) {
		
	  this.map_is_idle = false
      e.stopPropagation()
      e.preventDefault()
      const files = e.dataTransfer.files
      if (files.length !== 1) {
        this.$vs.notify({
          title: 'Invalid file count',
          text: 'Only support uploading one file!',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
        return
      }
      const rawFile = files[0] // only use files[0]
      if (!this.isExcel(rawFile)) {
        this.$vs.notify({
          title: 'Invalid file',
          text: 'Only supports upload .xlsx, .xls, .csv suffix files',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
        return false
      }
      this.importExcel(files)
	},
    isExcel (file) {
      return /\.(xlsx|xls|csv)$/.test(file.name)
    },
    handleClick (e) {
		
	  this.map_is_idle = false
      const files = e.target.files
      const rawFile = files[0]
      if (!rawFile) return
      this.importExcel(files)
	},
	
  }
}
</script>

<style lang="scss">
.is-loading:before {
	width: 100%;
    height: 100%;
    display: block;
    content: "" attr(remaining) "";
    color: #7055e9;
    background: #f0f0f2;
    position: fixed;
    z-index: 999;
    margin: 0;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    text-align: center;
    // padding-top: 5vh;
    background-image: url(https://cdn.dribbble.com/users/1133416/screenshots/5495916/attachments/1188843/loader.gif);
    background-size: 150px;
    background-repeat: no-repeat;
    // background-position: center center;
	
	padding-top: 35vh;
    background-position: center 25em;

}
span.counter-remaining {
    z-index: 9999;
    position: absolute;
    top: 2em;
    right: 2em;
}
</style>